// extracted by mini-css-extract-plugin
export default {"pickerContainer":"CustomLabelPicker_pickerContainer__fdgqj"};